import Err from '../../models/err';

export default function createGreaterThanError(attrName, value) {
  return new Err({ code: Err.Code.GREATER_THAN, attr: attrName, detail: `Value should be greater than ${value}` });
}
